import {
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
  Table,
  TableHead,
  Button,
  CircularProgress,
  Box,
  Typography,
} from "@mui/material";
import Iconify from "../iconify/Iconify";
import { getDivisionNameByLevel } from "src/utils/cardUtils";

export default function DivisionLeaguesTable(props) {
  return props.rows === null ? (
    <Box
      sx={{ display: "flex", justifyContent: "center" }}
      style={{ padding: 20 }}
    >
      <CircularProgress />
    </Box>
  ) : (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>League ID</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Stage Period</TableCell>
            <TableCell>Size</TableCell>
            <TableCell>Promotion Status</TableCell>
            <TableCell>IsActive</TableCell>
            <TableCell align="right"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.rows.length === 0 && (
            <Typography
              variant="body2"
              sx={{ padding: 2, textAlign: "center", width: "100%" }}
            >
              No leagues found
            </Typography>
          )}

          {props?.rows?.map((row, index) => {
            const isLast = index === props.rows.length - 1;
            return (
              <TableRow
                key={index}
                ref={isLast && props.lastRowRef ? props.lastRowRef : null}
                sx={{
                  "&:last-child td, &:last-child th": { border: 0 },
                }}
              >
                <TableCell component="th" scope="row">
                  {row.leagueId}
                </TableCell>
                <TableCell component="th" scope="row">
                  {getDivisionNameByLevel(row.divisionLevel)}
                </TableCell>
                <TableCell component="th" scope="row">
                  {row.stagePeriodId}
                </TableCell>
                <TableCell component="th" scope="row">
                  {row.membersCount}
                </TableCell>
                <TableCell component="th" scope="row">
                  {row.promotionStatus}
                </TableCell>
                <TableCell component="th" scope="row">
                  {row.isActive ? (
                    <Iconify
                      icon={"eva:checkmark-circle-2-outline"}
                      sx={{ color: "green" }}
                    />
                  ) : (
                    <Iconify
                      icon={"eva:close-circle-outline"}
                      sx={{ color: "red" }}
                    />
                  )}
                </TableCell>
                <TableCell align="right">
                  {props.showLeaderboard && (
                    <Button
                      variant="outlined"
                      onClick={() => props.onLeaderboardClick(row.leagueId)}
                      sx={{ mr: 2 }}
                    >
                      Leaderboard
                    </Button>
                  )}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
